import request from "@/utils/request";

// 获取手机号列表
export const getPhonePageList = (params) => {
    return request({
        url: '/sys/workPhones/getPageList',
        method: 'POST',
        data: params
    })
}
// 新增手机号
export const addPhone = (params) => {
    return request({
        url: '/sys/workPhones/add',
        method: 'POST',
        data: params
    })
}
//修改
export const editPhone = (params) => {
    return request({
        url: '/sys/workPhones/update',
        method: 'POST',
        data: params
    })
}


// 分配号卡
export const assignPhone = (params) => {
    return request({
        url: '/sys/workPhoneAssignment/add',
        method: 'POST',
        data: params
    })
}
//分配记录
export const loadAssignRecord = (params) => {
    return request({
        url: '/sys/workPhoneAssignment/getPageList',
        method: 'POST',
        data: params
    })
}

/**
 * 导入号卡
 * @param query
 * @returns {AxiosPromise}
 */
export const importPhone = (file) => {
    return request({
        url: '/sys/workPhones/importWorkPhone',
        headers: {
            "Content-type": "multipart/form-data",
        },
        method: 'post',
        data: file
    });
};
/**
 * 导入费用分摊
 * @param file
 * @returns {AxiosPromise}
 */
export const importCostDivide = (file) => {
    return request({
        url: '/sys/workPhoneCost/importWorkPhoneCost',
        headers: {
            "Content-type": "multipart/form-data",
        },
        method: 'post',
        data: file
    });
};

//查询号码和费用统计
export const getPhoneCount = (params) => {
    return request({
        url: '/sys/workPhones/getPhoneCount',
        method: 'POST',
        data: params
    })
}


/**
 * 查询所有教练
 */
export const getListCoachAll = (name) => {
    return request({
        url: '/sys/coach/getListCoachAll',
        method: 'get',
        params: name
    });
};

//导出号卡管理
export function exportExcel(query) {
    return request({
        url: '/sys/workPhones/exportExcel',
        method: 'post',
        data: query,
        responseType: 'arraybuffer'
    })
}
//导出费用分摊
export function exportCostExcel(query) {
    return request({
        url: '/sys/workPhoneCost/exportExcel',
        method: 'post',
        data: query,
        responseType: 'arraybuffer'
    })
}



//计算 某月的费用分摊
export const computePhoneCost = (params) => {
    return request({
        url: '/sys/workPhoneCost/computePhoneCost',
        method: 'POST',
        data: params
    })
}

//分页查询 费用记录
export const fetchCostList = (params) => {
    return request({
        url: '/sys/workPhoneCost/getPageList',
        method: 'POST',
        data: params
    })
}

//修改-费用
export const editPhoneCost = (params) => {
    return request({
        url: '/sys/workPhoneCost/update',
        method: 'POST',
        data: params
    })
}

